/** Shared skeleton palette — warm brand-adjacent, never cool slate. */
export const SKELETON_THEME = {
  baseColor: '#f0e6dc',
  highlightColor: '#fff9f3',
  accentBase: '#e8d4c0',
  accentHighlight: '#fde9d6',
  borderRadius: '12px',
  duration: 1.35,
};

export const skeletonProps = {
  baseColor: SKELETON_THEME.baseColor,
  highlightColor: SKELETON_THEME.highlightColor,
};

export const skeletonAccentProps = {
  baseColor: SKELETON_THEME.accentBase,
  highlightColor: SKELETON_THEME.accentHighlight,
};
